import React from 'react';
import { useState, useEffect, useRef, useMemo } from 'react';
import { AxiosInstance } from '../../utils';
import NewsletterModal from '../../NewsLetterModal';

interface HeaderProps {
  events?: any[];
}

const Header: React.FC<HeaderProps> = ({ events = [] }) => {
     const [responsiveMenu, setResponsiveMenu] = useState(false);
     const [dropdownOpen, setDropdownOpen] = useState(false);
     const [archiveOpen, setArchiveOpen] = useState(false);
     const [archiveEvents, setArchiveEvents] = useState<any[]>([]);
     const [newsletterOpen, setNewsletterOpen] = useState(false);
     const dropdownRef = useRef<HTMLLIElement>(null);
     const archiveRef = useRef<HTMLLIElement>(null);
         const onClickHandler = (e)=>{
            setResponsiveMenu(!responsiveMenu);
         };
         const toggleDropdown = (e: React.MouseEvent) => {
            e.preventDefault();
            setDropdownOpen(!dropdownOpen);
         };
         const toggleArchive = (e: React.MouseEvent) => {
            e.preventDefault();
            setArchiveOpen(!archiveOpen);
         };
         
         const openNewsletter = () => {
            setNewsletterOpen(true);
         };
         
         const closeNewsletter = () => {
            setNewsletterOpen(false);
         };
         useEffect(() => {
            const fetchArchiveEvents = async () => {
              try {
                const response = await AxiosInstance.get('/api/getevent?eventstatus=CLOSED');
                if (response.data.result === 'Success') {
                  if (response.data.data.length === 0) {
                    setArchiveEvents([{ name: 'NO ARCHIVAL', eventcode: '' }]);
                  } else {
                    setArchiveEvents(response.data.data);
                  }
                }
              } catch (error) {
                console.error('Error fetching archive events:', error);
              }
            };
            fetchArchiveEvents();
          }, []);
         const latestEvents = useMemo(() => {
            const sorted = [...events].sort((a, b) => new Date(b.startdate).getTime() - new Date(a.startdate).getTime());
            return sorted.slice(0, 2);
          }, [events]);

        
  return (
    <>
     <header className="mainwebsitehomefixed animated slideDown">
        <div className="container">
            <div className="header-content">
                <div className="row">
                    <div className="col-lg-2 col-md-6 col-sm-6 col-10">
                        <div className="logo">
                           <a href="/" > <div className="sec-title">
                            <img src="../../images/bb.png" />
                            </div></a>
                             {/*   <!--sec-title end-->  */}
                        </div> {/*  <!--logo end-->  */}
                    </div>
                    <div className="col-lg-10 col-md-6 col-sm-6 col-2">

                        <nav>
                        <ul>
                                {latestEvents.map((event, index) => (
          <li key={event.eventcode}><a href={`/event/${event.eventcode}`}>#{event.eventcode}</a></li>
        ))}
        <li><a href="/cfp">CFP</a></li>
        <li><a href="/blogs">Blog</a></li>
        <li><a href="/gallery">Gallery</a></li>
        <li><a href="/contact">Contact</a></li>
       <li className="nav-item dropdown" ref={archiveRef}>
        <a className="nav-link dropdown-toggle" href="#" onClick={toggleArchive} role="button" aria-haspopup="true" aria-expanded={archiveOpen}>
          Archive
        </a>
        <div className={`dropdown-menu ${archiveOpen ? 'show' : ''}`} aria-labelledby="navbarDropdown">
          {archiveEvents.map(event => (
            event.eventcode ? (
              <a key={event.eventcode} className="dropdown-item" href={`/event/${event.eventcode}`}>#{event.eventcode}</a>
            ) : (
              <span key="no-archival" className="dropdown-item disabled">{event.name}</span>
            )
          ))}
        </div>
      </li>
       <li className="nav-item dropdown" ref={dropdownRef}>
        <a className="nav-link dropdown-toggle" href="#" onClick={toggleDropdown} role="button" aria-haspopup="true" aria-expanded={dropdownOpen}>
          About
        </a>
        <div className={`dropdown-menu ${dropdownOpen ? 'show' : ''}`} aria-labelledby="navbarDropdown">
          <a className="dropdown-item" href="/aboutus">About Us</a>
          <a className="dropdown-item" href="/teammembers">Team</a>
          <a className="dropdown-item" href="/codeofconduct">Code of Conduct</a>
        </div>
      </li>
       <li> <div className="social-icons" aria-label="Social Media Links">
           <a onClick={openNewsletter} title="Newsletter" aria-label="Newsletter">
              <i className="fa fa-envelope"></i>
            </a>
          <a href="https://lnkd.in/gZ8N3Kxr" title="LinkedIn"  target='_about' aria-label="LinkedIn">
           <i className="fa fa-linkedin"></i>
          </a>
         <a href="https://x.com/bsidesbangalore" title="Twitter" target='_about' aria-label="Twitter">
             <i className="fa fa-twitter"></i> </a>
          <a href="https://www.instagram.com/bsides_bangalore" title="instagram" target='_about' aria-label="instagram">
           <i className="fa fa-instagram"></i>
          </a>
            <a href="https://www.youtube.com/channel/UC0SqOU2NDDIP0bbt5OwW8Hw" title="youtube" target='_about' aria-label="youtube">
           <i className="fa fa-youtube"></i>
          </a>
        </div></li>
                    </ul>   
                        </nav> 
                         <div className={"menu-btn" + (responsiveMenu ? " active ":"")} onClick={onClickHandler}>
                            <span className="bar1"></span>
                            <span className="bar2"></span>
                            <span className="bar3"></span>
                        </div> {/* <!--menu-btn end--> */}
                    </div>
                </div>
            </div> {/* <!--header-content end--> */}
        </div>
    </header> {/* <!--header end--> */}


    
    <div className={"responsive-mobile-menu" + (responsiveMenu ? " active ":"")}>
        <ul>
                                {latestEvents.map((event, index) => (
          <li key={event.eventcode}><a href={`/event/${event.eventcode}`}>{event.name}</a></li>
        ))}
        <li><a href="/cfp">CFP</a></li>
        <li><a href="/blogs">Blog</a></li>
        <li><a href="/gallery">Gallery</a></li>
       <li> <a href="#" onClick={toggleArchive}>Archive <i className={`fa fa-caret-${archiveOpen ? 'down' : 'right'}`}></i></a></li>
       {archiveOpen && archiveEvents.map(event => (
         <li key={event.eventcode || 'no-archival'}>
           {event.eventcode ? (
             <a href={`/event/${event.eventcode}`} style={{paddingLeft: '20px'}} onClick={() => setArchiveOpen(false)}>{event.name}</a>
           ) : (
             <span style={{paddingLeft: '20px'}}>{event.name}</span>
           )}
         </li>
       ))}
       <li> <a href="#" onClick={toggleDropdown}>About <i className={`fa fa-caret-${dropdownOpen ? 'down' : 'right'}`}></i></a></li>
       {dropdownOpen && (
         <>
           <li><a href="/aboutus" style={{paddingLeft: '20px'}} onClick={() => setDropdownOpen(false)}>About Us</a></li>
           <li><a href="/teammembers" style={{paddingLeft: '20px'}} onClick={(e) => { e.preventDefault(); window.location.href = '/teammembers'; }}>Team</a></li>
           <li><a href="/codeofconduct" style={{paddingLeft: '20px'}} onClick={() => setDropdownOpen(false)}>Code of Conduct</a></li>
         </>
       )}
       <li> <div className="social-icons" aria-label="Social Media Links">
         <a onClick={openNewsletter} title="Newsletter" aria-label="Newsletter">
              <i className="fa fa-envelope"></i>
            </a>
          <a href="https://lnkd.in/gZ8N3Kxr" title="LinkedIn"  target='_about' aria-label="LinkedIn">
           <i className="fa fa-linkedin"></i>
          </a>
          <a href="https://x.com/bsidesbangalore" title="Twitter" target='_about' aria-label="Twitter">
          <i className="fa fa-twitter"></i>
          </a>
        </div></li>
         <li> <div className="social-icons" aria-label="Social Media Links">
        
          <a href="https://www.instagram.com/bsides_bangalore" title="instagram" target='_about' aria-label="instagram">
           <i className="fa fa-instagram"></i>
          </a>
           <a href="https://www.youtube.com/channel/UC0SqOU2NDDIP0bbt5OwW8Hw" title="youtube" target='_about' aria-label="youtube">
           <i className="fa fa-youtube"></i>
          </a>
        </div></li>
                    </ul>   
                    
                       
    </div> {/* <!--responsive-mobile-menu end--> */}
    
    <NewsletterModal 
      isOpen={newsletterOpen} 
      onClose={closeNewsletter} 
    />
    </>
  );
};

export default Header;